// extracted by mini-css-extract-plugin
module.exports = {"upload__button":"upload_avatar-module__upload__button___QQyg+","upload__icon":"upload_avatar-module__upload__icon___nRHgO"};